var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNowblogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79753e-06 32C4.89568e-06 8 8.00001 2.73372e-06 32 4.83187e-06C56 6.93001e-06 64 8.00001 64 32C64 56 56 64 32 64C8 64 6.99382e-07 56 2.79753e-06 32Z",
    fill: "#E9C66C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6821 23.9802C32.5266 23.8247 32.3157 23.7373 32.0958 23.7373H25.5883C25.0691 23.7373 24.5713 23.9435 24.2042 24.3106C23.8371 24.6777 23.6309 25.1756 23.6309 25.6947V39.3966C23.6309 39.9157 23.8371 40.4136 24.2042 40.7807C24.5713 41.1478 25.0691 41.354 25.5883 41.354H39.2902C39.8093 41.354 40.3072 41.1478 40.6743 40.7807C41.0413 40.4136 41.2476 39.9157 41.2476 39.3966V32.8891",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7806 35.9583C34.0443 35.8923 34.2852 35.756 34.4774 35.5637L43.7752 26.266C44.4458 25.5953 44.8226 24.6857 44.8226 23.7373C44.8226 22.7888 44.4458 21.8792 43.7752 21.2086C43.1045 20.5379 42.1949 20.1611 41.2464 20.1611C40.298 20.1611 39.3884 20.5379 38.7177 21.2086L29.42 30.5063C29.2278 30.6985 29.0914 30.9394 29.0254 31.2031L28.0467 35.118C27.9189 35.6291 28.0687 36.1698 28.4413 36.5424C28.8139 36.915 29.3546 37.0648 29.8658 36.937L33.7806 35.9583Z",
    fill: "white",
    stroke: "#E9C66C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowblogIcon);
export default __webpack_public_path__ + "static/media/nowblog-icon.bd3bea7b0c77639b3bef46c78b5906c7.svg";
export { ForwardRef as ReactComponent };